import OriginTypography from './components/Typography';
import Text from './components/Text';
import Link from './components/Link';
import Title from './components/Title';
import Paragraph from './components/Paragraph';
export var Typography = Object.assign(OriginTypography, {
  Text: Text,
  Link: Link,
  Title: Title,
  Paragraph: Paragraph
});